export default {
  title: `Oups!
          <br /> Quelque chose ne va pas`,
  description: `<p>Quelque chose a mal tourné.</p>
                <p>
                  Veuillez réessayer plus tard. Si le problème persiste, contactez notre
                  équipe d'assistance pour obtenir de l'aide.
                </p>`,
};
